import { ReactElement } from 'react';
import { space } from '@op/opds.tokens';
import { Message, useMessage } from '@messageformat/react';
import TextRowComponent from './TextRowComponent';
import InvestingPath from './InvestingPath';
import CourseHeader from '../CourseHeader';
import { ReactComponent as Image128 } from '../../images/symbol_misc_priorities_128.svg';
import { ReactComponent as Image139 } from '../../images/OP_symbolikuvitus_96_139.svg';
import { ReactComponent as Image075 } from '../../images/OP_symbolikuvitus_96_075.svg';
import { ReactComponent as Image02 } from '../../images/symbol_misc_notification_02_96.svg';
import { ReactComponent as ImageSun } from '../../images/sun.svg';
import { ReactComponent as ImageLoss } from '../../images/symbol_insurance_loss_96.svg';
import { ReactComponent as Image008 } from '../../images/OP_symbolikuvitus_96_008.svg';
import { ReactComponent as Image96 } from '../../images/no_search_results_96.svg';
import { ReactComponent as ImageBonus } from '../../images/symbol_ownercustomer_Bonus_account_96.svg';
import { ReactComponent as ImageBook } from '../../images/symbol_misc_book_96.svg';
import parseMsgContent from '../../util/parseMsgContent';
import CourseContent from '../CourseContent';
import CompleteAcademy from './CompleteAcademy';
import TextComponent from '../TextComponent';

const Course10 = (): ReactElement => {
  const intro = useMessage('course10.intro');
  const basicsText = useMessage('course10.basics');
  const firsInvestText = useMessage('course10.first_investment');
  const fearText = useMessage('course10.fear');
  const marketText = useMessage('course10.investing_market');
  const illusionText = useMessage('course10.price_illusion');

  const parsedIntro = parseMsgContent(intro);
  const parsedBasics = parseMsgContent(basicsText);
  const parsedInvest = parseMsgContent(firsInvestText);
  const parsedFear = parseMsgContent(fearText);
  const parsedMarket = parseMsgContent(marketText);
  const parsedIllusion = parseMsgContent(illusionText);
  return (
    <div style={{ marginBottom: space.default }}>
      <CourseHeader
        courseTitleId="course10.title"
        courseHeaderText="learn_more"
        Image={Image128}
        courseNumber={10}
      />
      <div style={{ marginBottom: space.large }}>
        <CourseContent content={parsedIntro} />
      </div>
      <div style={{ marginBottom: space.large }}>
        <Image139 className="investoracademy-small-svg" aria-hidden="true" />
        <CourseContent content={parsedBasics} headingAs="h2" />
      </div>
      <TextRowComponent
        number="1"
        titleId="course10.part1.title"
        msgId="course10.part1.body"
      />
      <TextRowComponent
        number="2"
        titleId="course10.part2.title"
        msgId="course10.part2.body"
      />
      <TextRowComponent
        number="3"
        titleId="course10.part3.title"
        msgId="course10.part3.body"
      />
      <div style={{ marginBottom: space.large }}>
        <Image075 className="investoracademy-small-svg" aria-hidden="true" />
        <CourseContent content={parsedInvest} headingAs="h2" />
      </div>
      <TextRowComponent
        number="4"
        titleId="course10.part4.title"
        msgId="course10.part4.body"
      />
      <div style={{ marginBottom: space.large }}>
        <ImageSun className="investoracademy-small-svg" aria-hidden="true" />
        <CourseContent content={parsedFear} headingAs="h2" />
      </div>
      <TextRowComponent
        number="5"
        titleId="course10.part5.title"
        msgId="course10.part5.body"
      />
      <Image02 className="investoracademy-small-svg" aria-hidden="true" />
      <CourseContent content={parsedMarket} headingAs="h2" />
      <div style={{ textAlign: 'center', paddingTop: space.large }}>
        <h3 className="opds-styles-v1-text-title-xl" style={{ marginBottom: space.xs }}>
          <Message id="course10.investing_psychology.title" />
        </h3>
        <TextComponent
          messageId="course10.investing_psychology.body"
          twoColumns={false}
        />
      </div>
      <InvestingPath />
      <TextRowComponent
        number="6"
        titleId="course10.part6.title"
        msgId="course10.part6.body"
      />
      <TextRowComponent
        number="7"
        titleId="course10.part7.title"
        msgId="course10.part7.body"
      />
      <ImageLoss
        className="investoracademy-small-svg investoracademy-course10-svg"
        aria-hidden="true"
      />
      <TextRowComponent
        number="8"
        titleId="course10.part8.title"
        msgId="course10.part8.body"
      />
      <TextRowComponent
        number="9"
        titleId="course10.part9.title"
        msgId="course10.part9.body"
      />
      <Image008
        className="investoracademy-small-svg investoracademy-course10-svg"
        aria-hidden="true"
      />
      <TextRowComponent
        number="10"
        titleId="course10.part10.title"
        msgId="course10.part10.body"
      />
      <div style={{ marginBottom: space.large }}>
        <Image96 className="investoracademy-small-svg" aria-hidden="true" />
        <CourseContent content={parsedIllusion} headingAs="h2" />
      </div>
      <TextRowComponent
        number="11"
        titleId="course10.part11.title"
        msgId="course10.part11.body"
      />
      <TextRowComponent
        number="12"
        titleId="course10.part12.title"
        msgId="course10.part12.body"
      />
      <ImageBonus
        className="investoracademy-small-svg investoracademy-course10-svg"
        aria-hidden="true"
      />
      <TextRowComponent
        number="13"
        titleId="course10.part13.title"
        msgId="course10.part13.body"
      />
      <TextRowComponent
        number="14"
        titleId="course10.part14.title"
        msgId="course10.part14.body"
      />
      <ImageBook
        className="investoracademy-small-svg investoracademy-course10-svg"
        aria-hidden="true"
      />
      <TextRowComponent
        number="15"
        titleId="course10.part15.title"
        msgId="course10.part15.body"
      />
      <CompleteAcademy />
    </div>
  );
};

export default Course10;
